export const WEATHER_CITIES = [
  'Miami',
  'Toronto',
  'Bangkok',
  'Antalya',
  'London',
  'New York',
  'Kyiv',
  'Warsaw',
  'Berlin',
  'Amsterdam',
  'Phuket',
  'Lviv',
  'Ternopil',
  'Copenhagen',
  'Oslo',
  'Palma',
];

export const NUMBERS = [
  { numberMinParam: 0, numberMaxParam: 100 },
  { numberMinParam: 1, numberMaxParam: 100 },
  { numberMinParam: 0, numberMaxParam: 10 },
  { numberMinParam: 0, numberMaxParam: 9 },
  { numberMinParam: 0, numberMaxParam: 36 },
];

export const RANDOM_NUMBER_DIGITS = [
  { numberOfNumbersParam: 1, numberOfDigitsParam: 2 },
  { numberOfNumbersParam: 1, numberOfDigitsParam: 4 },
  { numberOfNumbersParam: 1, numberOfDigitsParam: 6 },
  { numberOfNumbersParam: 1, numberOfDigitsParam: 8 },
  { numberOfNumbersParam: 1, numberOfDigitsParam: 10 },
  { numberOfNumbersParam: 2, numberOfDigitsParam: 2 },
  { numberOfNumbersParam: 2, numberOfDigitsParam: 4 },
  { numberOfNumbersParam: 2, numberOfDigitsParam: 6 },
  { numberOfNumbersParam: 2, numberOfDigitsParam: 8 },
  { numberOfNumbersParam: 2, numberOfDigitsParam: 10 },
];

export const BREATHING_EXERCISE_DATA = {
  '4-7-8': {
    breatheIn: 4000,
    hold: 7000,
    breatheOut: 8000,
    label: '4 7 8',
    labelWords: ['four', 'seven', 'eight'],
    keywords:
      '4 7 8 breathing technique, 478 deep breathing, 4 7 8 breathing dr weil, dr weil 4 7 8, 4 7 8 technique, 4 7 8 andrew weil, 4 7 8 breathing method benefits, breathe in for 4 seconds hold for 7, 4 7 8 yoga breathing technique',
  },
  '4-5-8': {
    breatheIn: 4000,
    hold: 5000,
    breatheOut: 8000,
    label: '4 5 8',
    labelWords: ['four', 'five', 'eight'],
    keywords:
      '4 5 8 breathing technique, 4 5 8 technique, 4 5 8 breathing method benefits, 4 5 8 yoga breathing technique',
  },
  '4-5-6': {
    breatheIn: 4000,
    hold: 5000,
    breatheOut: 6000,
    label: '4 5 6',
    labelWords: ['four', 'five', 'six'],
    keywords:
      '4 5 6 breathing technique, 4 5 6 technique, 4 5 6 breathing method benefits, 4 5 6 yoga breathing technique',
  },
  '4-6-8': {
    breatheIn: 4000,
    hold: 6000,
    breatheOut: 8000,
    label: '4 6 8',
    labelWords: ['four', 'six', 'eight'],
    keywords:
      '4 6 8 breathing technique, 4 6 8 technique, 4 6 8 breathing method benefits, 4 6 8 yoga breathing technique',
  },
  '3-7-8': {
    breatheIn: 3000,
    hold: 7000,
    breatheOut: 8000,
    label: '3 7 8',
    labelWords: ['three', 'seven', 'eight'],
    keywords:
      '3 7 8 breathing technique, 3 7 8 technique, 3 7 8 breathing method benefits, 3 7 8 yoga breathing technique',
  },
  '2-7-8': {
    breatheIn: 2000,
    hold: 7000,
    breatheOut: 8000,
    label: '2 7 8',
    labelWords: ['two', 'seven', 'eight'],
    keywords:
      '2 7 8 breathing technique, 2 7 8 technique, 2 7 8 breathing method benefits, 2 7 8 yoga breathing technique',
  },
  '3-4-5': {
    breatheIn: 3000,
    hold: 4000,
    breatheOut: 5000,
    label: '3 4 5',
    labelWords: ['three', 'four', 'five'],
    keywords:
      '3 4 5 breathing technique, 3 4 5 technique, 3 4 5 breathing method benefits, 3 4 5 yoga breathing technique',
  },
  '4-4-4': {
    breatheIn: 4000,
    hold: 4000,
    breatheOut: 4000,
    label: '4 4 4',
    labelWords: ['four', 'four', 'four'],
    keywords:
      '4 4 4 breathing technique, 444 breathing technique, 4 4 4 technique, 4 4 4 breathing method benefits, 4 4 4 yoga breathing technique',
  },
};

export const tabsNameGenerator = [
  {
    label: 'Name',
    value: 'name',
    title: 'Name generator',
    keywords: [
      'generator name',
      'the name generator',
      'ai name generator',
      'baby name generator',
      'random name generator',
      'stylish name generator',
    ],
  },
  {
    label: 'Middle name',
    value: 'middle-name',
    title: 'Middle name generator',
    keywords: ['Middle name generator'],
  },
  {
    label: 'Last name',
    value: 'last-name',
    title: 'Last name generator',
    keywords: ['last name generator'],
  },
  {
    label: 'Username',
    value: 'username',
    title: 'Username generator',
    keywords: ['generator username'],
  },
  {
    label: 'Elf',
    value: 'elf',
    title: 'Elf name generator',
    keywords: ['Generate elf name'],
  },
  {
    label: 'Jedi',
    value: 'jedi',
    title: 'Jedi name generator',
    keywords: ['generator Jedi name'],
  },
  {
    label: 'Zoo',
    value: 'zoo',
    title: 'Zoo name generator',
    keywords: ['generator zoo name'],
  },
  {
    label: 'Dnd',
    value: 'dnd',
    title: 'dnd name generator',
    keywords: ['generator dnd name'],
  },
  {
    label: 'Bgmi',
    value: 'bgmi',
    title: 'BGMI name generator',
    keywords: ['generator name for BGMI'],
  },
  {
    label: 'PUBG',
    value: 'pubg',
    title: 'PUBG name generator',
    keywords: ['generator name PUBG'],
  },
  {
    label: 'Villain',
    value: 'villain',
    title: 'Villain name generator',
    keywords: ['generator villain name'],
  },
  {
    label: 'Japanese',
    value: 'japanese',
    title: 'Japanese name generator',
    keywords: ['generator Japanese name'],
  },
];

export const TOOLS = [
  {
    title: 'Gameplay (ColdTrace & Stalkie answers)',
    url: 'gameplay',
  },
  { title: 'Number Generator', url: 'numbergenerator' },
  {
    title: 'Random digit number generator',
    url: 'random-digit-number-generator',
  },
  { title: 'Random number wheel', url: 'random-number-wheel' },
  { title: 'List randomizer wheel', url: 'list-randomizer-wheel' },
  {
    title: 'Random color generator React',
    url: 'random-color-generator-react',
  },
  { title: 'Random QR code', url: 'random-qr-code' },
  { title: 'Star rating', url: 'star-rating' },
  { title: 'GitHub profile search', url: 'github-profile-search' },
  { title: 'Weather app', url: 'weather-app' },
  { title: 'Eye gymnastics', url: 'eye-gymnastics' },
  { title: '7-11 breathing app', url: '7-11-breathing-app' },
  { title: 'Breathing app', url: 'breathing-app' },
  { title: 'Recipes', url: 'recipes' },
  { title: 'GitHub contribution chart', url: 'github-contribution-chart' },
  { title: '90 day rule calculator', url: '90-day-rule-calculator' },
  {
    title: 'Character headcanon generator',
    url: 'character-headcanon-generator',
  },
  {
    title: 'Name generator',
    url: 'name-generator',
  },
  {
    title: 'Brat generator',
    url: 'brat-generator',
  },
];
